import { Component, OnInit, ViewChild } from '@angular/core';
import { SeafarerAdminService } from '../../../core/seafarer-admin.service'
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { SeafarerViewAccessService } from '../../../core/seafarer-view-access.service';
import { ChatService } from '../../../core/chat.service';


@Component({
  selector: 'app-seafarers-details',
  templateUrl: './seafarers-details.component.html',
  styleUrls: ['./seafarers-details.component.css']
})
export class SeafarersDetailsComponent implements OnInit {
  @ViewChild('galleryModal') galleryModal: ModalDirective;
  token;
  seafarerId;
  seafarer = {
    userId: 0,
    imgUrl: '',
    firstName: '',
    middleName: '',
    lastName: '',
    lastRankOn: '',
    schoolGraduated: '',
    address: '',
    licenseCOC: '',
    vesselTypeExp: '',
    prevManningAgency: '',
    facebookLink: '',
    phone: ''
  };
  infoPage = 2;
  currentImg;
  docs = {
    coc: 'C.O.C',
    validPassport: 'Passport',
    seamanBook: 'Seaman Book',
    src: 'SRC',
    ssc: 'SSC'
  };
  employmentContracts = [];
  seaBasedContracts = [];
  landBasedContracts = [];
  vesselTypeSummary = [];
  grandTotalServiceDays = 0;
  contractsLoading = true;
  canAccess = false;
  requested = false;
  requestMessage = 'REQUEST FOR AN ACCESS HERE.';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private seafarerService: SeafarerAdminService,
    private chatService: ChatService,
    private seafarerViewAccessService: SeafarerViewAccessService
  ) { }

  ngOnInit() {
    this.token = this.cookieService.get('token');
    this.seafarerId = this.route.snapshot.paramMap.get('id');

    this.seafarerService.getSeafarerProfile(this.token, this.seafarerId)
      .subscribe(res => {
        if (res && res.success) {
          this.seafarer = res.data;
        }
      });

    this.seafarerService.getEmploymentContracts(this.token, this.seafarerId)
      .subscribe(res => {
        this.contractsLoading = false;
        if (res && res.success) {
          this.employmentContracts = res.data.items || [];
          this.seaBasedContracts = this.employmentContracts.filter(c => c.type === 'sea-based');
          this.landBasedContracts = this.employmentContracts.filter(c => c.type === 'land-based');
        }
      });

    this.seafarerService.getVesselTypeSummary(this.token, this.seafarerId)
      .subscribe(res => {
        if (res && res.success) {
          this.vesselTypeSummary = res.data.vessel_type_summary || [];
          this.grandTotalServiceDays = res.data.grand_total_service_days || 0;
        }
      });
  }

  showImg(url) {
    this.currentImg = url;
    this.galleryModal.show();
  }

  requestAccess() {
    if (!this.requested) {
      this.requestMessage  = 'WAIT TO ACCEPT YOUR REQUEST.';

      this.seafarerViewAccessService.requestAccess(this.token, this.seafarerId)
        .subscribe(res => this.toastr.success('Requested for an access!'));
    }

    this.requested = true;
  }

  messageSeafarer(userId) {
    const thread = {
      userId
    };

    this.chatService.createMessage(this.token, thread)
      .subscribe(res => {
        if (res && res.success) {
          const {threadId, userId} = res.data;
          this.router.navigate([`/school/student/messages/${threadId}/${userId}`]);
        }
      });
  }

}
